export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'works',
    name: '作品集',
    description: '安斋拉拉历年作品全收录，按发布时间排序，涵盖所有系列与特别企划。',
    icon: 'ri-movie-2-line',
    count: 86,
    imageSeq: 'cat-works-01',
  },
  {
    slug: 'profile',
    name: '资料档案',
    description: '完整的个人资料库，包括基本档案、职业生涯时间线、获奖荣誉等详尽信息。',
    icon: 'ri-profile-line',
    count: 24,
    imageSeq: 'cat-profile-01',
  },
  {
    slug: 'news',
    name: '最新动态',
    description: '追踪安斋拉拉最新消息，涵盖新作发布、媒体采访、社交动态、活动日程等。',
    icon: 'ri-flashlight-line',
    count: 128,
    imageSeq: 'cat-news-01',
  },
  {
    slug: 'community',
    name: '粉丝社区',
    description: '粉丝交流互动专区，分享心得、讨论作品、组织活动，共建温馨粉丝家园。',
    icon: 'ri-heart-line',
    count: 356,
    imageSeq: 'cat-community-01',
  },
  {
    slug: 'gallery',
    name: '精选图集',
    description: '精选安斋拉拉高清写真与活动照片，定期更新，带来视觉盛宴。',
    icon: 'ri-image-line',
    count: 45,
    imageSeq: 'cat-gallery-01',
  },
  {
    slug: 'interviews',
    name: '深度访谈',
    description: '收录安斋拉拉各类专访与深度对谈，了解银幕背后最真实的她。',
    icon: 'ri-chat-1-line',
    count: 18,
    imageSeq: 'cat-interviews-01',
  },
];